import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useApp } from "../context/AppContext";
import { api, errMsg } from "../lib/api";
import { PageHeader, Field } from "../components/bits";
import { STRUCTURE_TYPES } from "../components/StructureSwitcher";

export default function StructureForm({ edit, embedded }) {
  const { sp, sid, setSid, reloadMe } = useApp();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", type: "tournee", tour_start: "", tour_end: "", default_needed: 1 });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  useEffect(() => {
    if (edit && sid) api.get(sp("")).then(({ data }) => setF({ name: data.name, type: data.type, tour_start: data.tour_start || "", tour_end: data.tour_end || "", default_needed: data.default_needed || 1 }));
  }, [edit, sid, sp]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      if (edit) {
        await api.put(sp(""), f);
        toast.success("Enregistré");
        await reloadMe();
      } else {
        const { data } = await api.post("/structures", f);
        await reloadMe();
        setSid(data.id);
        toast.success("Équipe créée");
        nav("/equipe");
      }
    } catch (err) { toast.error(errMsg(err)); }
  };

  const remove = async () => {
    if (!window.confirm("Supprimer définitivement cette équipe ?")) return;
    try { await api.delete(sp("")); localStorage.removeItem("sid"); await reloadMe(); nav("/"); } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div data-testid="structure-form-page">
      {!embedded && <PageHeader title="Créer une équipe" back="/" />}
      <form onSubmit={submit} className="space-y-4">
        <Field label="Nom"><input className="field" required minLength={2} value={f.name} onChange={set("name")} placeholder="Tournée Clément" data-testid="structure-name-input" /></Field>
        <Field label="Activité">
          <div className="grid gap-2">
            {Object.entries(STRUCTURE_TYPES).map(([k, l]) => (
              <button type="button" key={k} onClick={() => setF({ ...f, type: k })} className={`chip !justify-start !rounded-xl ${f.type === k ? "chip-on" : "chip-off"}`} data-testid={`structure-type-${k}`}>{l}</button>
            ))}
          </div>
        </Field>
        {!["missions", "individuel"].includes(f.type) && (
          <Field label="Infirmières nécessaires par jour">
            <input type="number" min={1} max={10} className="field" value={f.default_needed} onChange={(e) => setF({ ...f, default_needed: Number(e.target.value) || 1 })} data-testid="structure-needed-input" />
          </Field>
        )}
        {f.type !== "missions" && (
          <Field label="Horaires habituels (facultatif)">
            <div className="grid grid-cols-2 gap-3">
              <input type="time" className="field" value={f.tour_start} onChange={set("tour_start")} data-testid="structure-start-input" />
              <input type="time" className="field" value={f.tour_end} onChange={set("tour_end")} data-testid="structure-end-input" />
            </div>
          </Field>
        )}
        <button className="btn-primary w-full" data-testid="structure-save-btn">{edit ? "Enregistrer" : "Créer"}</button>
        {edit && <button type="button" className="w-full py-2 text-sm font-semibold text-red-600" onClick={remove} data-testid="structure-delete-btn">Supprimer l'équipe</button>}
      </form>
    </div>
  );
}
